import { Timestamp } from '@firebase/firestore';

import type { IntakeStatusBaseSteps } from '@shared/patient-intake-status';

type BuildGenerateConsentToReleaseHealthSummaryStepParams = {
  latestHealthSummaryReleaseId: unknown | null;
  defaultActionedBy: IntakeStatusBaseSteps[keyof IntakeStatusBaseSteps]['currentStatus']['actionedBy'];
};

export const buildGenerateConsentToReleaseHealthSummaryStep = ({
  latestHealthSummaryReleaseId,
  defaultActionedBy,
}: BuildGenerateConsentToReleaseHealthSummaryStepParams): IntakeStatusBaseSteps['GENERATE_CONSENT_TO_RELEASE_HEALTH_SUMMARY'] => {
  if (!latestHealthSummaryReleaseId || typeof latestHealthSummaryReleaseId !== 'string') {
    return {
      id: 'GENERATE_CONSENT_TO_RELEASE_HEALTH_SUMMARY',
      type: 'GENERATE_CONSENT_TO_RELEASE_HEALTH_SUMMARY',
      stepType: 'BASE_STEP',
      updatedAt: Timestamp.now(),
      currentStatus: {
        note: null,
        metadata: null,
        actionedAt: null,
        status: 'NOT_STARTED',
        actionedBy: defaultActionedBy,
      },
      isDisabled: true,
    };
  }

  return {
    id: 'GENERATE_CONSENT_TO_RELEASE_HEALTH_SUMMARY',
    type: 'GENERATE_CONSENT_TO_RELEASE_HEALTH_SUMMARY',
    stepType: 'BASE_STEP',
    updatedAt: Timestamp.now(),
    currentStatus: {
      note: null,
      metadata: {
        fileUploadDocId: latestHealthSummaryReleaseId,
      },
      actionedAt: null,
      status: 'COMPLETED',
      actionedBy: defaultActionedBy,
    },
    isDisabled: true,
  };
};
